import {
  Box,
  lgBumps,
  LinkAnchor,
  LinkAnchorProps,
  Typo,
  xlBumps,
} from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import { getCurrentQuote } from '../../../../domain'
import { useEditProposal } from '../../../../hooks/proposal'
import {
  TKey,
  useWriskTranslation,
} from '../../../../infrastructure/internationalisation'
import { ReferralReasons } from '../../../organisms/quote'
import { WriskTrans } from '../../../organisms/trans'
import { FullPage } from '../../../templates'
import { useProposal } from '../ProposalProvider'
import { ReferralUpsellSection } from '../upsell/ReferralUpsellSection'

const tKey = TKey('pages.proposal-referral')

const CheckAnswersLink: FunctionComponent<LinkAnchorProps> = ({
  children,
  onClick,
  ...props
}) => (
  <LinkAnchor onClick={onClick} {...props}>
    {children}
  </LinkAnchor>
)

export const ProposalReferralPage: FunctionComponent = () => {
  const { t } = useWriskTranslation()

  const { proposal } = useProposal()

  const quote = getCurrentQuote(proposal)

  const handleEdit = useEditProposal(proposal)

  const subheader = t(tKey('subheader'), { defaultValue: null }) ? (
    <WriskTrans t={t} i18nKey={tKey('subheader')} />
  ) : null

  return (
    <FullPage pageId='referral' header={t(tKey('header'))} subheader={subheader}>
      <ReferralReasons quote={quote} mb={lgBumps} width={1} />
      <Box width={1} mb={xlBumps}>
        <Typo>
          <WriskTrans
            t={t}
            i18nKey={tKey('actions.check')}
            components={{
              CheckAnswersLink: <CheckAnswersLink onClick={handleEdit} />,
            }}
          />
        </Typo>
      </Box>
      <ReferralUpsellSection proposal={proposal} />
    </FullPage>
  )
}
